<template>
  <v-footer color="secondary" dark class="pt-10 pb-6">
    <v-container>
      <v-row>
        <v-col cols="12" md="3">
          <div class="d-flex align-center mb-4">
            <v-img
              :src="require('@/assets/logoaveo.png')"
              max-height="44"
              max-width="120"
              contain
              class="mr-2"
              alt="Aveo Perú Logo"
            />
            <span class="ml-1 text-h6 font-weight-bold">Aveo Perú</span>
          </div>
          <p class="body-2 grey--text text--lighten-2 mb-4">
            Software de facturación electrónica y gestión empresarial. Cumple
            con todas las exigencias de SUNAT.
          </p>
          <div class="d-flex">
            <v-btn
              v-for="social in socials"
              :key="social.icon"
              icon
              small
              class="mr-1"
              :href="social.href"
              target="_blank"
              rel="noopener"
              :aria-label="social.label"
            >
              <v-icon size="22">{{ social.icon }}</v-icon>
            </v-btn>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <h3 class="text-subtitle-1 font-weight-bold mb-4">Empresa</h3>
          <ul class="footer-list">
            <li><a href="#">Nosotros</a></li>
            <li><a href="#">Clientes</a></li>
            <li><router-link :to="{ name: 'Index' }">Inicio</router-link></li>
          </ul>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <h3 class="text-subtitle-1 font-weight-bold mb-4">Servicios</h3>
          <ul class="footer-list">
            <li>
              <router-link :to="{ name: 'PequenosNegocios' }"
                >Pequeños negocios</router-link
              >
            </li>
            <li><a href="#">Facturación electrónica</a></li>
            <li><a href="#">Certificados digitales</a></li>
          </ul>
        </v-col>

        <v-col cols="12" md="3">
          <h3 class="text-subtitle-1 font-weight-bold mb-4">
            Soporte &amp; Legal
          </h3>
          <ul class="footer-list mb-4">
            <li><a href="#">Centro de ayuda</a></li>
          </ul>
          <div class="d-flex align-start mb-2">
            <v-icon small class="mr-2 mt-1">mdi-phone</v-icon>
            <span class="body-2">(+51) 958863622</span>
          </div>
          <div class="d-flex align-start mb-2">
            <v-icon small class="mr-2 mt-1">mdi-email-outline</v-icon>
            <span class="body-2">jmcalderon@aveoperu.com</span>
          </div>
          <div class="d-flex align-start">
            <v-icon small class="mr-2 mt-1">mdi-map-marker-outline</v-icon>
            <span class="body-2">Lima, Perú — Atención nacional</span>
          </div>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col
          cols="12"
          md="6"
          class="d-flex align-center justify-center justify-md-end"
        >
          <span class="caption grey--text text--lighten-1">
            © {{ year }} Aveo Perú. Todos los derechos reservados.
          </span>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {
      year: new Date().getFullYear(),
      socials: [
        {
          icon: "mdi-facebook",
          href: "https://web.facebook.com/aveoperu",
          label: "Facebook",
        },
        {
          icon: "mdi-youtube",
          href: "https://www.youtube.com/@aveoperu248",
          label: "YouTube",
        },
        {
          icon: "mdi-whatsapp",
          href: "https://wa.me/51958863622",
          label: "WhatsApp",
        },
      ],
    };
  },
};
</script>

<style scoped>
.footer-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-list li {
  margin-bottom: 10px;
}

.footer-list a {
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  font-size: 0.875rem;
  transition: color 0.2s;
}

.footer-list a:hover {
  color: #ffcc80;
}

.map-placeholder {
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.map-placeholder__inner {
  min-height: 140px;
  background: linear-gradient(
    135deg,
    rgba(21, 101, 192, 0.35) 0%,
    rgba(13, 71, 161, 0.5) 100%
  );
}
</style>
